<template>
    <div class="context">
        <div class="header">
            <div class="search">
                <el-page-header @back="back" :content="viewTitle">
                </el-page-header>
            </div>
        </div>

        <div class="main_box">
            <div class="left_btn" v-if="!disabled">
                <div class="title">题目控件</div>

                <div v-for="(item, index) in btn_list"
                     :key="index"
                     @click="addForm(item)"
                     class="btn_item">
                    <span class="iconfont" :class="item.icon"></span>
                    <span>{{item.name}}</span>
                </div>
            </div>

            <div class="right_page">
                <div class="top_tabs">
                    <div class="tab"
                         :class="tab_id===1?'active_tab':''"
                         @click="changeTab(1)">第1页</div>
                    <div class="tab"
                         :class="tab_id===2?'active_tab':''"
                         @click="changeTab(2)">结束页</div>
                </div>
                <div v-if="tab_id === 1" class="page start_page">
                    <div class="title_box box">
                        <div v-if="showTitle"
                             @click="showInput('showTitle')"
                             class="title text">
                            {{page_form.title}}
                        </div>
                        <div v-else class="input">
                            <el-input v-model="page_form.title"
                                      @keyup.enter.native="editTitle"
                                      @blur="editTitle"
                                      class="width_all_100 all_height"></el-input>
                        </div>
                    </div>
                    <div class="description box">
                        <div v-if="showDes"
                             @click="showInput('showDes')"
                             class="des_text text">
                            {{page_form.start_description}}
                        </div>
                        <div v-else class="input">
                            <el-input v-model="page_form.start_description"
                                      @keyup.enter.native="editDes"
                                      @blur="editDes"
                                      type="textarea"
                                      :rows="3"
                                      class="width_all_100 all_height"></el-input>
                        </div>
                    </div>

                    <div class="ques_list" v-if="question_list.length > 0">
                        <div v-for="(item, index) in question_list"
                             :key="index"
                             class="ques_item">
                            <div v-if="item.qtype === 'RADIO'">
                                <radio-view :des="item"
                                            :disabled="disabled"
                                            @changeQues="getForm"
                                            :num="index + 1"></radio-view>
                            </div>
                            <div v-if="item.qtype === 'SELECT'">
                                <select-view :des="item"
                                             :disabled="disabled"
                                            @changeQues="getForm"
                                            :num="index + 1"></select-view>
                            </div>
                            <div v-if="item.qtype === 'CHECKBOX'">
                                <check-box-view :des="item"
                                                :disabled="disabled"
                                             @changeQues="getForm"
                                             :num="index + 1"></check-box-view>
                            </div>
                            <div v-if="item.qtype === 'INPUT'">
                                <input-view :des="item"
                                            :disabled="disabled"
                                             @changeQues="getForm"
                                             :num="index + 1"></input-view>
                            </div>
                            <div v-if="item.qtype === 'TEXTAREA'">
                                <textarea-view :des="item"
                                               :disabled="disabled"
                                             @changeQues="getForm"
                                             :num="index + 1"></textarea-view>
                            </div>
                            <div v-if="item.qtype === 'TEXT'">
                                <text-view :des="item"
                                           :disabled="disabled"
                                           @changeQues="getForm"
                                           :num="index + 1"></text-view>
                            </div>
                            <div v-if="item.qtype === 'PROVINCE_CITY'">
                                <city-view :des="item"
                                           :disabled="disabled"
                                           @changeQues="getForm"
                                           :num="index + 1"></city-view>
                            </div>
                            <div v-if="item.qtype === 'DATE'">
                                <day-view :des="item"
                                          :disabled="disabled"
                                           @changeQues="getForm"
                                           :num="index + 1"></day-view>
                            </div>
                            <div v-if="item.qtype === 'DATETIME'">
                                <time-view :des="item"
                                           :disabled="disabled"
                                           @changeQues="getForm"
                                           :num="index + 1"></time-view>
                            </div>
                            <div v-if="item.qtype === 'SCORE_SELECT'">
                                <scor-select :des="item"
                                             :disabled="disabled"
                                           @changeQues="getForm"
                                           :num="index + 1"></scor-select>
                            </div>
                            <div v-if="item.qtype === 'SCORE_RADIO'">
                                <scor-radio :des="item"
                                            :disabled="disabled"
                                           @changeQues="getForm"
                                           :num="index + 1"></scor-radio>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="tab_id === 2" class="page end_page">
                    <div class="img">
                        <span class="iconfont icon-refuse"></span>
                    </div>
                    <div class="end_box box">
                        <div v-if="showEnd"
                             @click="showInput('showEnd')"
                             class="text">
                            {{page_form.end_description}}
                        </div>
                        <div v-else class="input">
                            <el-input v-model="page_form.end_description"
                                      @keyup.enter.native="editEnd"
                                      @blur="editEnd"
                                      type="textarea"
                                      :rows="3"
                                      class="width_all_100 all_height"></el-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex"
    import {clone} from "@/global/utils";
    import radioView from "./form_module/radio_v"
    import checkBoxView from "./form_module/checkbox_v"
    import selectView from "./form_module/select_v"
    import textView from "./form_module/text_v"
    import textareaView from "./form_module/textarea_v"
    import inputView from "./form_module/input_v"
    import cityView from "./form_module/city_v"
    import dayView from "./form_module/day_v"
    import timeView from "./form_module/time_v"
    import scorSelect from "./form_module/scor_select_v"
    import scorRadio from "./form_module/scor_radio_v"

    export default {
        name: "add",
        components: {
            inputView,
            radioView,
            checkBoxView,
            selectView,
            textView,
            textareaView,
            cityView,
            dayView,
            timeView,
            scorSelect,
            scorRadio,
        },
        data() {
            return {
                btn_list: [
                    {name: '单选题', icon: 'icon-danxuan_xuanzhong', value: 'RADIO'},
                    {name: '下拉题', icon: 'icon-xiala', value: 'SELECT'},
                    {name: '多选题', icon: 'icon-duoxuan_xuanzhong1', value: 'CHECKBOX'},
                    {name: '单行文本题', icon: 'icon-danhangshuru', value: 'INPUT'},
                    {name: '多行文本题', icon: 'icon-duohangwenben', value: 'TEXTAREA'},
                    {name: '文本描述', icon: 'icon-wenbenmiaoshu', value: 'TEXT'},
                    {name: '省市', icon: 'icon-shengshi', value: 'PROVINCE_CITY'},
                    {name: '日期', icon: 'icon-rili', value: 'DATE'},
                    {name: '计分下拉', icon: 'icon-xiala', value: 'SCORE_SELECT'},
                    {name: '计分单选', icon: 'icon-danxuan_xuanzhong', value: 'SCORE_RADIO'},
                    {name: '时间', icon: 'icon-shijian1', value: 'DATETIME'},
                ],
                tab_id: 1,

                page_form: {
                    title:'问卷标题',
                    start_description: '为了给您提供更好的服务，希望您能抽出几分钟时间，将您的感受和建议告诉我们，我们非常重视每位用户的宝贵意见，期待您的参与！现在我们就马上开始吧！',
                    end_description: '问卷到此结束，感谢您的参与！',
                },
                showTitle: true,
                showDes: true,
                showEnd: true,

                question_list: []
            }
        },
        computed: {
            ...mapState('questionData', {
                viewTitle: 'title',
                survey_id: 'survey_id',
                edit_ques: 'edit_ques'
            }),
            disabled() {
                return this.viewTitle === '查看问卷'
            }
        },
        mounted() {
            this.setEditQues(false);
            if (this.survey_id) {
                console.log(this.survey_id, '156');
                this.getForm();
            } else {
                //添加新问卷
                this.addTab()
            }
        },
        methods: {
            ...mapMutations('questionData', {
                setEditQues: 'setEditQues'
            }),
            getForm() {
                let id = this.survey_id || this.page_form.survey_id;
                this.httpGet(`/survey/detail/${id}`).then(res => {
                    this.page_form = res.data;
                    this.question_list = clone(this.page_form.questions);
                });
            },
            back() {
                this.$emit('changeTopTab', 'tableView')
            },
            addForm(item) {
                // console.log(item, 'add form---');
                if(this.tab_id === 2) {
                    this.$message.warning('只能在第一页添加题目');
                    return
                }
                if (this.edit_ques) {
                    this.$message.warning('已有题目处于编辑状态');
                    return
                }
                let has_options = [
                    'RADIO',
                    'SELECT',
                    'CHECKBOX',
                    'SCORE_SELECT',
                    'SCORE_RADIO',
                ];
                let params = {
                    title: '',
                    description: '',
                    qtype: item.value,
                    survey_id: this.page_form.survey_id,
                    required: 2,
                    score: 10,
                    field_name: '',
                    options: [],
                };
                if (has_options.indexOf(item.value) > -1) {
                    params.options = [
                        {content: "选项", score: 1,}, //  option_id: 1 有id表示更新
                        {content: "选项", score: 1,},
                    ]
                }
                this.question_list.push(params);
                this.setEditQues(true);
                // console.log(this.question_list, '221');
            },

            addTab() {
                // 添加 更新新问卷
                let params = {
                    ...this.page_form
                };
                this.httpPost('/survey/save', params).then(res => {
                    this.page_form = res.data
                })
            },
            changeTab(val) {
                // 切换页码
                this.tab_id = val
            },
            showInput(name) {
                this[name] = false
            },
            // 保存标标题、开始描述、结尾描述
            editTitle() {
                console.log(this.page_form.title, '114');
                this.showTitle = true;
                this.addTab()
            },
            editDes() {
                this.showDes = true;
                this.addTab()
            },
            editEnd() {
                this.showEnd = true;
                this.addTab()
            },
        }
    }
</script>

<style lang="scss">
    .all_height {
        .el-input__inner {
            /*height: 100%;*/
            /*line-height: 100%;*/
            border-radius: 1px;
        }
    }
</style>
<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;
        background: #fff;
        .header {
            height: 45px;
            line-height: 45px;

            display: flex;
            justify-content: space-between;
            padding: 0 20px;
            .search {
                padding-top: 15px;
            }
        }
        .main_box {
            display: flex;
            height: calc(100% - 50px);
            overflow: hidden;
            background: #F0F0F0;
            padding: 10px;
            box-sizing: border-box;
            .left_btn {
                flex: 0 0 220px;
                background: #FAFAFA;
                padding: 10px;
                box-sizing: border-box;
                .title {
                    font-size: 1.125rem;
                    font-weight: 600;
                    text-align: center;
                    line-height: 40px;
                    margin-bottom: 5px;
                }
                .btn_item {
                    border: 1px solid #ccc;
                    border-radius: 2px;
                    padding: 10px;
                    margin: 5px;
                    cursor: pointer;
                    background: #fff;
                    font-size: .875rem;
                    .iconfont {
                        margin-right: 5px;
                    }
                }
            }
            .right_page {
                flex: 1;
                margin: 0 5px;
                box-sizing: border-box;
                display: flex;
                flex-flow: column;
                overflow: hidden;
                height: 100%;
                .top_tabs {
                    flex: 0 0 40px;
                    max-width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    border-bottom: 1px solid #e0e0e0;
                    border-left: 1px solid #e0e0e0;
                    color: #333;
                    cursor: pointer;
                    .tab {
                        display: flex;
                        justify-content: center;
                        line-height: 40px;
                        width: 100px;
                        border-top: 1px solid #e0e0e0;
                        border-right: 1px solid #e0e0e0;
                        padding: 0 5px;
                        box-sizing: border-box;
                        font-size: .875rem;
                        cursor: pointer;
                        background: #fafafa;
                    }
                    .active_tab {
                        background: #fff;
                    }
                }
                .page {
                    flex: 1;
                    width: 100%;
                    background: #fff;
                    box-sizing: border-box;
                    color: #333333;
                    overflow-y: auto;
                    padding: 50px 0;
                    .box {
                        background: #fff;
                        border-top: 1px solid #fff;
                        border-bottom: 1px solid #fff;
                        padding: 5px 0;
                        &:hover {
                            background-color: #fafafa;
                            border-top: 1px solid #e0e0e0;
                            border-bottom: 1px solid #e0e0e0;
                        }
                        .text {
                            background: #fff;
                            margin: 0 15%;
                            border: 1px solid #fff;
                            cursor: text;
                            line-height: 40px;
                            box-sizing: border-box;
                            &:hover {
                                border: 1px solid #e0e0e0;
                            }
                        }
                        .input {
                            margin: 0 15%;
                        }
                    }
                    .title_box {
                        text-align: center;
                        .title {
                            font-size: 1.5rem;
                            height: 40px;
                        }
                    }
                    .description {
                        text-align: left;
                        .des_text {
                            font-size: .875rem;
                            height: 75px;
                        }
                    }
                    .ques_list {

                    }
                }
                .end_page {
                    .img {
                        text-align: center;
                        margin: 100px 15% 0;
                        background: #fff;
                        border: 1px solid #fff;
                        .iconfont {
                            font-size: 5rem;
                        }
                    }
                    .end_box {
                        text-align: center;
                        .text {
                            font-size: .875rem;
                            height: 75px;
                        }
                    }
                }
            }
        }
    }
</style>